import { RemoveScroll } from '@hover/blueprint';
import type { ComponentProps } from 'react';
import React from 'react';

import { isServer } from 'src/shared/utils/environment';

/**
 * The `RemoveScroll` component uses `useLayoutEffect` which is not supported
 * when server rendering, so only render `RemoveScroll` on the client.
 *
 * @todo(design-system) wrap the `RemoveScroll` component exported by
 * `@hover/blueprint` so we don't need to worry about this in userland
 */
export const SafeRemoveScroll = (props: ComponentProps<typeof RemoveScroll>) =>
  isServer() ? <div>{props?.children}</div> : <RemoveScroll {...props} />;
